import storeConnection from './container';
import Header from './Header';

export default storeConnection(Header);
